import { TabPanels, TabPanel, TabList, TabGroup, Tab } from '../Tabs';
import { useEffect, useState } from 'react';
import { fetchProfessional } from '../../providers/professionals';
import GeneralTab from '../professional-form/GeneralTab';
import ScheduleTab from '../professional-form/ScheduleTab';
import GapsTab from './GapsTab';
import { useTranslations } from '../../providers/i18n';

const tabs = ['Geral', 'Horário', 'Excepções'];

function normalizeOldInput(oldInput = {}) {
    const normalized = { ...oldInput };

    if (normalized.specialties) {
        normalized.specialties = normalized.specialties.filter(Boolean).map((id) => ({ id: parseInt(id) }));
    }

    if (normalized.schedule) {
        normalized.schedule = Array.isArray(normalized.schedule) ? normalized.schedule : Object.values(normalized.schedule);
        normalized.scheduleBaselineIndexes = Array.isArray(normalized.scheduleBaselineIndexes) ? normalized.scheduleBaselineIndexes : Object.values(normalized.scheduleBaselineIndexes || {});
        normalized.schedule = normalized.schedule.filter((entry) => entry && entry.start && entry.duration);

        if (normalized.scheduleBaselineIndexes) {
            normalized.schedule = normalized.schedule.map((entry, index) => ({
                ...entry,
                baseline_index: normalized.scheduleBaselineIndexes[index],
            }));
        }
    }

    if (normalized.gaps) {
        normalized.gaps = Array.isArray(normalized.gaps) ? normalized.gaps : Object.values(normalized.gaps);
        normalized.gapBaselineIndexes = Array.isArray(normalized.gapBaselineIndexes) ? normalized.gapBaselineIndexes : Object.values(normalized.gapBaselineIndexes || {});
        normalized.gaps = normalized.gaps.filter((entry) => entry && entry.start && entry.end);

        if (normalized.gapBaselineIndexes) {
            normalized.gaps = normalized.gaps.map((entry, index) => ({
                ...entry,
                baseline_index: normalized.gapBaselineIndexes[index],
            }));
        }
    }

    return normalized;
}

function ProfessionalForm({ id: professionalId, clinic_id, currentTab, oldInput }) {
    const [t, translationsLoaded] = useTranslations('professional-form');
    const normalizedOldInput = normalizeOldInput(oldInput);
    const [baselineProfessional, setBaselineProfessional] = useState({ clinic_id });
    const [professional, setProfessional] = useState({ clinic_id, ...normalizedOldInput });

    useEffect(async () => {
        if (professionalId) {
            const fetchedProfessional = await fetchProfessional(professionalId);

            setBaselineProfessional(fetchedProfessional);
            setProfessional({
                ...fetchedProfessional,
                ...normalizedOldInput,
            });
        }
    }, []);

    if (professionalId && !professional.id) return null;
    if (!translationsLoaded) return null;

    return (
        <TabGroup className="flex h-full flex-col" tabKey="professionalFormTab" defaultIndex={currentTab} hashIds={['general', 'schedule', 'gaps']}>
            <TabList className="mx-4">
                <Tab>{t('tabs.general')}</Tab>
                <Tab>{t('tabs.schedule')}</Tab>
                <Tab>{t('tabs.gaps')}</Tab>
            </TabList>
            <TabPanels className="flex-1 overflow-auto p-4">
                <TabPanel>
                    <GeneralTab professional={professional} setProfessional={setProfessional} showClinic={!clinic_id} t={t} />
                </TabPanel>
                <TabPanel>
                    <ScheduleTab schedule={professional.schedule} baselineSchedule={baselineProfessional.schedule} t={t} />
                </TabPanel>
                <TabPanel>
                    <GapsTab gaps={professional.gaps} baselineGaps={baselineProfessional.gaps} t={t} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    );
}

export default ProfessionalForm;
